import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Organization } from '../../interfaces/api/organization';
import { fetchOrganizations } from '../services/organizations.service';

interface OrganizationState {
	organizations: {
		[id: number]: Organization;
	};
	selectedOrganization: Organization | undefined;
	isLoading: boolean;
}

const initialState = {
	organizations: [],
	selectedOrganization: undefined,
	isLoading: false,
} as OrganizationState;

export const fetchOrganizationsThunk = createAsyncThunk<Organization[], void>(
	'organization/fetchOrganizations',
	async (_undefined, { rejectWithValue }) => {
		try {
			return await fetchOrganizations();
		} catch (error) {
			return rejectWithValue(error);
		}
	}
);

const organizationSlice = createSlice({
	name: 'organization',
	initialState,
	reducers: {
		selectOrganization: (state, action: PayloadAction<number>) => {
			state.selectedOrganization = state.organizations[action.payload];
		},
		unselectOrganization: (state) => {
			state.selectedOrganization = undefined;
		},
		resetOrganization: (state) => {
			Object.assign(state, initialState);
		},
	},
	extraReducers: (builder) => {
		builder.addCase(fetchOrganizationsThunk.fulfilled, (state, action) => {
			const ret: { [id: number]: Organization } = {};
			state.organizations = action.payload.reduce((obj, organization) => {
				obj[organization.id] = organization;
				return obj;
			}, ret);
			state.isLoading = false;
		});
		builder.addCase(fetchOrganizationsThunk.pending, (state) => {
			state.isLoading = true;
		});
		builder.addCase(fetchOrganizationsThunk.rejected, (state, action) => {
			state.organizations = [];
			state.isLoading = false;
		});
	},
});

export const { selectOrganization, unselectOrganization, resetOrganization } =
	organizationSlice.actions;

export default organizationSlice;
